import { Button, Card } from 'react-bootstrap';
import { API_BASE_URL } from '../../api/api';

export const ProductList = ({
    loadingProducts,
    productsByUser,
    isSelected,
    toggleProduct,
    formatPrice
}) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {loadingProducts ? (
                <p className="text-center">Cargando productos...</p>
            ) : productsByUser.length === 0 ? (
                <div
                    className="d-flex justify-content-center align-items-center text-center"
                    style={{ minHeight: '300px' }}
                >
                    <h4 className="text-muted">No hay productos para este usuario</h4>
                </div>
            ) : (
                productsByUser.map((product) => {
                    const selected = isSelected(product.id);
                    const image = product.images?.[product.mainImage || 0];
                    const imageUrl = image
                        ? `${API_BASE_URL}/product/get/file/${image}`
                        : 'https://via.placeholder.com/300x180?text=Sin+Imagen';

                    return (
                        <Card key={product.id} className="mb-0">
                            <div className="d-flex align-items-stretch">
                                {/* Imagen a la izquierda */}
                                <div
                                    className="product-img"
                                    style={{
                                        width: '120px',
                                        height: '120px',
                                        overflow: 'hidden',
                                        position: 'relative',
                                        flexShrink: 0,
                                    }}
                                >
                                    {product.status === 'sale' && (
                                        <span className="ribbon ribbon-danger">Sale</span>
                                    )}
                                    {product.status === 'Hot' && (
                                        <span className="ribbon ribbon-clip ribbon-warning">Hot</span>
                                    )}

                                    <img
                                        className="img-fluid"
                                        src={imageUrl}
                                        alt={product.title}
                                        style={{
                                            height: '100%',
                                            width: '100%',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </div>

                                {/* Detalles a la derecha */}
                                <div className="p-2 d-flex flex-column justify-content-between flex-grow-1">
                                    <div>
                                        <h6 className="mb-1">{product.title}</h6>
                                        <p className="text-muted small mb-1">{product.shortDescription}</p>
                                        <div className="text-muted fw-semibold small">    
                                            {formatPrice(product.aditionalData[0].price_local_currency)}
                                        </div>
                                    </div>

                                    <div className="mt-1">
                                        <Button
                                            variant={selected ? 'success' : 'primary'}
                                            size="sm"
                                            className="py-0 px-2"
                                            onClick={() => !selected && toggleProduct(product.id, true)}
                                            disabled={selected}
                                        >
                                            {selected ? 'Agregado' : 'Agregar'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    );
                })
            )}
        </div>
    );
};
